import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { ArrowBackIcon } from '../../../../assets/icons';
import './styles.scss';
import { validateSmsVerificationCodeStart } from '../../../../redux/user/user.actions';
import {
  setSignupWizardActivePageName,
  setUserOtpToken,
} from '../../../../redux/app/app.actions';
import useTranslation from 'hooks/useTranslation';

const VERIFICATION_CODE_VALID_LENGTH = 4;
const VerificationForm = ({ mobile }) => {
  const dispatch = useDispatch();
  const [verificationCode, setVerificationCode] = useState('');
  const [error, setError] = useState();
  const isValidVerificationCodeLength =
    verificationCode &&
    verificationCode.length === VERIFICATION_CODE_VALID_LENGTH;

  const { getTranslation } = useTranslation('COMMON');
  const { t } = getTranslation();

  const onSuccessfullCodeVerify = (otpToken) => {
    dispatch(setUserOtpToken(otpToken));
    dispatch(setSignupWizardActivePageName('widget-generating'));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!isValidVerificationCodeLength) return;

    dispatch(
      validateSmsVerificationCodeStart({
        mobile,
        verificationCode,
        setError,
        onSuccess: onSuccessfullCodeVerify,
      })
    );
  };

  const handleChange = (event) => {
    const { value, maxLength } = event.target;
    setVerificationCode(value.slice(0, maxLength));
  };

  const handleGoBackToSignup = () => {
    dispatch(setSignupWizardActivePageName('signup'));
  };

  return (
    <form
      className='form'
      id='verification_form'
      onSubmit={handleSubmit}
      noValidate
    >
      <div className='form_control flex'>
        <input
          name='verificationCode'
          value={verificationCode}
          onChange={handleChange}
          type='number'
          placeholder={t('VERIFICATION_FORM').CODE_PLACEHOLDER}
          id='verifyPhone'
          maxLength={VERIFICATION_CODE_VALID_LENGTH}
          className={`${error === 'code is incorrect' ? 'error_input' : ''}`}
          autoFocus
        />
      </div>
      <div className='form_control flex button error_container'>
        {error === 'code is incorrect' ? (
          <span className='error_message'>
            {t('ENTERED_CODE_WRONG_TRY_AGAIN')}
          </span>
        ) : null}
        <input
          type='submit'
          value={t('VERIFICATION_FORM').SUBMIT_BTN}
          className={clsx('btn ml-1', {
            'btn-primary': isValidVerificationCodeLength,
            'btn-primary-disabled': !isValidVerificationCodeLength,
          })}
        />
        <div className='back'>
          <a href='#/' onClick={handleGoBackToSignup} className='flex'>
            <span>{t('VERIFICATION_FORM').CANCEL_BTN}</span>
            <img src={ArrowBackIcon} alt='' />
          </a>
        </div>
      </div>
    </form>
  );
};

VerificationForm.propTypes = {
  mobile: PropTypes.string.isRequired,
};

export default VerificationForm;
